import ethLogo from 'src/assets/icons/common/eth.png';
import wethLogo from 'src/assets/icons/common/weth.svg';
import wbtcLogo from 'src/assets/icons/common/wbtc.svg';
import usdtLogo from 'src/assets/icons/common/usdt.svg';
import usdcLogo from 'src/assets/icons/common/usdc.svg';

interface TokenLogoProps {
    tokenId: string;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const tokenLogos: Record<string, string> = {
    'ETH': ethLogo,
    'WETH': wethLogo,
    'USDT': usdtLogo,
    'USDC': usdcLogo,
    'WBTC': wbtcLogo,
};

const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
};

export function TokenLogo({ tokenId, size = 'md', className = '' }: TokenLogoProps) {
    const logoSrc = tokenLogos[tokenId.toUpperCase()];
    const sizeClass = sizeClasses[size];

    if (logoSrc) {
        return (
            <img
                src={logoSrc}
                alt={`${tokenId} logo`}
                className={`${sizeClass} rounded-full object-cover ${className}`}
            />
        );
    }

    // Fallback to first letter with gradient background
    return (
        <div
            className={`${sizeClass} rounded-full flex items-center justify-center text-white text-xs font-bold ${className}`}
            style={{ background: 'linear-gradient(45deg, #101FD0, #930AEC, #CB01F7)' }}
        >
            {tokenId.charAt(0)}
        </div>
    );
}

export default TokenLogo; 